import React from 'react';

const BestBetLabel = () => (
  <svg width="62px" height="17px" viewBox="0 0 62 17" className="sl-best-bet-label">
    <g id="regional-forecast" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="desktop---regional-forecast---premium-user"
        transform="translate(-267.000000, -269.000000)"
      >
        <g id="Group-6" transform="translate(92.000000, 224.000000)">
          <g id="best-bet" transform="translate(176.000000, 46.000000)">
            <path
              d="M9.82,11 L9.82,4.46 L11.91,4.46 C13.25,4.46 14.24,4.87 14.24,6.07 C14.24,6.69 13.89,7.29 13.12,7.49 L13.12,7.53 C14.06,7.69 14.59,8.2 14.59,9.08 C14.59,10.39 13.52,11 12.08,11 L9.82,11 Z M10.98,7.17 L11.8,7.17 C12.72,7.17 13.1,6.82 13.1,6.21 C13.1,5.61 12.68,5.36 11.83,5.36 L10.98,5.36 L10.98,7.17 Z M10.98,10.1 L11.96,10.1 C12.92,10.1 13.45,9.74 13.45,9 C13.45,8.32 12.93,8 11.96,8 L10.98,8 L10.98,10.1 Z M15.96,11 L15.96,4.46 L19.89,4.46 L19.89,5.44 L17.12,5.44 L17.12,7.11 L19.47,7.11 L19.47,8.09 L17.12,8.09 L17.12,10.02 L19.99,10.02 L19.99,11 L15.96,11 Z M21.05,10.16 L21.72,9.37 C22.19,9.81 22.82,10.11 23.43,10.11 C24.16,10.11 24.57,9.78 24.57,9.27 C24.57,8.73 24.15,8.56 23.55,8.31 L22.66,7.92 C22.01,7.65 21.34,7.14 21.34,6.18 C21.34,5.14 22.26,4.34 23.53,4.34 C24.3,4.34 25.04,4.66 25.55,5.17 L24.95,5.91 C24.54,5.56 24.09,5.35 23.53,5.35 C22.91,5.35 22.51,5.64 22.51,6.12 C22.51,6.63 23.01,6.82 23.55,7.04 L24.43,7.41 C25.21,7.74 25.75,8.23 25.75,9.18 C25.75,10.24 24.87,11.12 23.4,11.12 C22.52,11.12 21.67,10.77 21.05,10.16 Z M28.24,11 L28.24,5.44 L26.35,5.44 L26.35,4.46 L31.28,4.46 L31.28,5.44 L29.4,5.44 L29.4,11 L28.24,11 Z M34.8,11 L34.8,4.46 L36.89,4.46 C38.23,4.46 39.22,4.87 39.22,6.07 C39.22,6.69 38.87,7.29 38.1,7.49 L38.1,7.53 C39.04,7.69 39.57,8.2 39.57,9.08 C39.57,10.39 38.5,11 37.06,11 L34.8,11 Z M35.96,7.17 L36.78,7.17 C37.7,7.17 38.08,6.82 38.08,6.21 C38.08,5.61 37.66,5.36 36.81,5.36 L35.96,5.36 L35.96,7.17 Z M35.96,10.1 L36.94,10.1 C37.9,10.1 38.43,9.74 38.43,9 C38.43,8.32 37.91,8 36.94,8 L35.96,8 L35.96,10.1 Z M40.94,11 L40.94,4.46 L44.87,4.46 L44.87,5.44 L42.1,5.44 L42.1,7.11 L44.45,7.11 L44.45,8.09 L42.1,8.09 L42.1,10.02 L44.97,10.02 L44.97,11 L40.94,11 Z M47.8,11 L47.8,5.44 L45.91,5.44 L45.91,4.46 L50.84,4.46 L50.84,5.44 L48.96,5.44 L48.96,11 L47.8,11 Z"
              id="BEST-BET"
              fill="#22D736"
            />
            <rect
              id="Rectangle-15"
              stroke="#22D736"
              x="-0.5"
              y="-0.5"
              width="61"
              height="16"
              rx="2"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default BestBetLabel;
